var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#999;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-532 -172)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13,
    height: 13,
    transform: "translate(532 172)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(533.625 173.083)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 4.875,
    y1: 2.8,
    transform: "translate(2.438 1.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.75,9.555V5.238a1.078,1.078,0,0,0-.542-.933L8.417,2.147a1.087,1.087,0,0,0-1.083,0L3.542,4.3A1.078,1.078,0,0,0,3,5.238V9.555a1.078,1.078,0,0,0,.542.933l3.792,2.158a1.087,1.087,0,0,0,1.083,0l3.792-2.158A1.078,1.078,0,0,0,12.75,9.555Z",
    transform: "translate(-3 -2.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.27,6.96,8,9.685,12.728,6.96",
    transform: "translate(-3.124 -4.285)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 5.439,
    transform: "translate(4.875 5.395)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.e12e24033c71edda2a169097fb6f3b81.svg";
export { ForwardRef as ReactComponent };